exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message {\n  margin: 0px -23px 0px;\n  padding: 7px 30px 7px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmationdialog/confirmation-dialog.component.css
// module id = 2029
// module chunks = 0